<script>
const LangListAPI = "https://ams4you.net/amsapi/public/websearch/GetLangLanguageList";
const LangChangeAPI = "https://ams4you.net/amsapi/public/websearch/GetLangLanguageChange";

import axios from "axios";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
export default {
    components: {
        Datepicker,
    },
    data() {
        return {
            query: "",
            SelLang: {},
            SelCountry: {},
            SelWeek: {
                Id: 4,
                Name: "4 weeks",
            },
            SelDate: "",
            LanguageList: [],
            CountryList: [],
        };
    },
    computed: {
        WeekList() {
            let list = [];
            for (let i = 1; i <= 52; i++) {
                list.push({
                    Id: i,
                    Name: i == 1 ? i + " week" : i + " weeks",
                });
            }
            return list;
        },
        Setting() {
            return this.$parent.Setting;
        },
        Translation() {
            return this.$parent.Translation;
        },
    },
    watch: {
        SelLang(val) {
            this.SelCountry = {
                Id: 0,
                Name: "Ülke Seçiniz",
            };
            this.LanguageList.CountryList = [];
            if (val?.LanguageId) {
                let LatestQuery = this.query + "&LanguageId=" + val.LanguageId;
                this.GetCountries(LatestQuery);
            }
        },
    },
    methods: {
        MakeSearch() {
            let Path = "https://my.alternatifecs.com/search/language";

            let query = "?CountryId=" + this.SelCountry.Id + "&LevelId=" + this.SelLang.LanguageId + "&Weeks=" + this.SelWeek.Id + "&StartDate=" + moment(this.SelDate).format("YYYY-MM-DD");
            window.open(Path + query, this.Setting.OpenInNewWindow ? "_blank" : "_self");
        },
        async GetLanguageList() {
            let ag = this.$parent.ag;
            let wid = this.$parent.wid;
            this.query = "?ag=" + ag + "&wfid=" + wid;
            const request = await axios.get(LangListAPI + this.query);
            const response = request.data;
            this.LanguageList = response.detail;
        },
        async GetCountries(Query) {
            const request = await axios.get(LangChangeAPI + Query);
            const response = request.data;
            this.CountryList = response.detail;
        },
    },
    mounted() {
        this.GetLanguageList();
        this.SelDate = new Date(moment().add(1, "month").toJSON());
    },
};
</script>
<template>
    <div class="widget">
        <div class="widget-content">
            <div class="form-row">
                <v-select
                    class="form-control"
                    placeholder="Test"
                    :options="LanguageList"
                    :getOptionLabel="(option) => option.LanguageName || 'Dil Seçiniz'"
                    label="LanguageName"
                    :clearable="false"
                    v-model="SelLang"
                />
            </div>
            <div class="form-row" v-if="SelLang?.LanguageId">
                <v-select
                    class="form-control"
                    :options="CountryList"
                    label="Name"
                    :getOptionLabel="(option) => option.Name || 'Ülke Seçiniz'"
                    :clearable="false"
                    v-model="SelCountry"
                    :disabled="!SelLang?.LanguageId"
                />
            </div>
            <div class="form-grid" v-if="SelLang?.LanguageId && SelCountry?.Id">
                <div class="form-row">
                    <span class="form-row-label"> Eğitim Süresi </span>
                    <v-select class="form-control" :options="WeekList" label="Name" :getOptionLabel="(option) => option.Name || ''" :clearable="false" v-model="SelWeek" :disabled="!SelCountry?.Id" />
                </div>
                <div class="form-row">
                    <span class="form-row-label"> Başlangıç Tarihi </span>
                    <datepicker
                        :disabled-dates="{
                            to: new Date(),
                        }"
                        v-model="SelDate"
                        :disabled="!SelWeek?.Id || !SelCountry?.Id"
                        class="form-control"
                        :editable="false"
                        placeholder="Select date"
                        :format="'dd-MM-yyyy'"
                    ></datepicker>
                </div>
            </div>
        </div>
        <div class="widget-footer">
            <button type="submit" class="btn fw-500 px-4 text-center flex-grow-1" :disabled="!SelLang?.LanguageId || !SelWeek?.Id || !SelCountry?.Id || !SelDate" @click="MakeSearch()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search me-1 fs-9" viewBox="0 0 16 16" v-if="this.Setting.ShowIcons">
                    <path
                        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                    />
                </svg>
                Ara
            </button>
        </div>
    </div>
</template>
